import JobStatus from "../../../enums/job-status";
import { JobAdapter, UnifiedJobStatus } from "../job";

export default interface JobDto {
    jobId: string,
    // workParameters: JobParametersModel
    // jobResult: JobResultModel
    startTime: Date,
    lastUpdate: Date,
    progressInformation: string,
    progressPercentage: number,
    status: JobStatus
}

export const prodTaskAdapter: JobAdapter<JobDto> = {
    getId: (job) => job.jobId,
    getStatus: (job) => {
        switch (job.status) {
            case JobStatus.Pending:
                return UnifiedJobStatus.Pending;
            case JobStatus.Processing:
                return UnifiedJobStatus.Processing;
            case JobStatus.Success:
                return UnifiedJobStatus.Success;
            case JobStatus.Error:
                return UnifiedJobStatus.Error;
            default:
                return UnifiedJobStatus.Error;
        }
    },
    getProjectId: () => { throw new Error("No implemented"); },
    getFileNameResult: () => { throw new Error("No implemented"); }
};